module.exports = __webpack_public_path__ + "img/034.66c5e3c9.png";